import { render, staticRenderFns } from "./TemplateParser.vue?vue&type=template&id=5a5cb3ac&scoped=true&"
import script from "./TemplateParser.vue?vue&type=script&lang=js&"
export * from "./TemplateParser.vue?vue&type=script&lang=js&"
import style0 from "./TemplateParser.vue?vue&type=style&index=0&id=5a5cb3ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5cb3ac",
  null
  
)

export default component.exports